export const EVENT_TYPES = [
  {
    value: 'comicio',
    label: 'Comício',
    icon: 'i-lucide-megaphone',
    color: 'bg-rose-500',
    bgSoft: 'bg-rose-50',
    textOn: 'text-rose-700',
  },
  {
    value: 'carreata',
    label: 'Carreata',
    icon: 'i-lucide-car',
    color: 'bg-amber-500',
    bgSoft: 'bg-amber-50',
    textOn: 'text-amber-700',
  },
  {
    value: 'live',
    label: 'Live',
    icon: 'i-lucide-video',
    color: 'bg-purple-500',
    bgSoft: 'bg-purple-50',
    textOn: 'text-purple-700',
  },
  {
    value: 'reuniao',
    label: 'Reunião',
    icon: 'i-lucide-users',
    color: 'bg-blue-500',
    bgSoft: 'bg-blue-50',
    textOn: 'text-blue-700',
  },
  {
    value: 'debate',
    label: 'Debate',
    icon: 'i-lucide-mic-2',
    color: 'bg-indigo-500',
    bgSoft: 'bg-indigo-50',
    textOn: 'text-indigo-700',
  },
  {
    value: 'agenda_publica',
    label: 'Agenda pública',
    icon: 'i-lucide-calendar',
    color: 'bg-teal-500',
    bgSoft: 'bg-teal-50',
    textOn: 'text-teal-700',
  },
  {
    value: 'visita',
    label: 'Visita',
    icon: 'i-lucide-door-open',
    color: 'bg-emerald-500',
    bgSoft: 'bg-emerald-50',
    textOn: 'text-emerald-700',
  },
  {
    value: 'evento_interno',
    label: 'Evento interno',
    icon: 'i-lucide-briefcase',
    color: 'bg-slate-500',
    bgSoft: 'bg-slate-50',
    textOn: 'text-slate-700',
  },
];

export const EVENT_STATUSES = [
  {
    value: 'agendado',
    label: 'Agendado',
    color: 'bg-slate-100 text-slate-700',
  },
  {
    value: 'confirmado',
    label: 'Confirmado',
    color: 'bg-blue-100 text-blue-700',
  },
  {
    value: 'realizado',
    label: 'Realizado',
    color: 'bg-emerald-100 text-emerald-700',
  },
  {
    value: 'cancelado',
    label: 'Cancelado',
    color: 'bg-rose-100 text-rose-700',
  },
];

export const eventTypeMeta = v => EVENT_TYPES.find(e => e.value === v) || {};
export const eventStatusMeta = v =>
  EVENT_STATUSES.find(s => s.value === v) || {};
